module.exports = __webpack_public_path__ + "img/lucid.56760cf1.webp";